import React, { useState, useEffect, useRef } from 'react';
import { Box, Paper, Typography, IconButton, Stack } from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { height } from '@mui/system';

const getId = (item) => item?._id || item?.id || '';

const isExternalLink = (link) => /^https?:\/\//i.test(link || '');

const NotificationSlider = ({ notifications: propNotifications }) => {
    const [items, setItems] = useState([]);
    const [index, setIndex] = useState(0);
    const timer = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        let mounted = true;
        const load = async () => {
            if (Array.isArray(propNotifications) && propNotifications.length > 0) {
                const ordered = [...propNotifications]
                    .sort((a, b) => new Date(b.createdAt || b._createdAt || 0) - new Date(a.createdAt || a._createdAt || 0));
                if (mounted) setItems(ordered.slice(0, 5));
                return;
            }
            try {
                const res = await api.get('/notifications', { params: { limit: 5 } });
                const data = res?.data || [];
                const ordered = Array.isArray(data)
                    ? data.sort((a, b) => new Date(b.createdAt || b._createdAt || 0) - new Date(a.createdAt || a._createdAt || 0))
                    : [];
                if (mounted) setItems(ordered);
            } catch (e) {
                // fallback: no notifications
                if (mounted) setItems([]);
            }
        };
        load();
        return () => { mounted = false; };
    }, [propNotifications]);

    useEffect(() => {
        if (items.length <= 1) {
            clearInterval(timer.current);
            return;
        }
        timer.current = setInterval(() => setIndex((i) => (i + 1) % items.length), 5000);
        return () => clearInterval(timer.current);
    }, [items]);

    const prev = (event) => {
        event.stopPropagation();
        clearInterval(timer.current);
        setIndex((i) => (i - 1 + items.length) % items.length);
    };
    const next = (event) => {
        event.stopPropagation();
        clearInterval(timer.current);
        setIndex((i) => (i + 1) % items.length);
    };

    if (!items || items.length === 0) {
        return (
            <div className="col-12">
                <div className="card theme-bg" style={{
                    height:"100%"
                }}>
                    
                    <div className="card-body py-3" >
                        <div className="row">
                            <div className="col-auto justify-content-center align-items-center d-flex" style={{ minHeight: 60 }}>
                                <h6>اعلان خوانده‌ نشده‌ای ندارید.</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const item = items[index];
    const id = getId(item);

    const goToNotification = () => {
        const link = item?.link;
        if (link) {
            if (isExternalLink(link)) {
                window.open(link, '_blank', 'noopener,noreferrer');
            } else {
                navigate(link);
            }
            return;
        }
        if (id) navigate(`/notifications?highlight=${id}`);
    };

    const handleItemClick = () => {
        if (!id) return;
        setItems((prev) => prev.filter((it) => getId(it) !== id));
        goToNotification();
    };

    return (
        <div className="col-12" onClick={handleItemClick} style={{ cursor: 'pointer' }}>
            <div className="card theme-bg">
                 <div className="card-body py-3" style={{ position: 'relative' }}>
                    <div className="row">
                        <div className="col-auto align-self-center" style={{ height: 60, overflow: 'hidden', color: '#FFF' }}>
                            <span className="fw-light">{item.title}</span>
                        </div>
                        <div
                            className="col-auto"
                            style={{ position: 'absolute', left: 12, bottom: 12 }}
                        >
                            <Stack direction="row" spacing={0.5} alignItems="center">
                                <IconButton size="small" onClick={next} aria-label="next"><ArrowForwardIos fontSize="small" color='#FFF' /></IconButton>
                                <IconButton size="small" onClick={prev} aria-label="prev"><ArrowBackIos fontSize="small" color='#FFF' /></IconButton>
                            </Stack>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotificationSlider;
